<template>
  <div>
    <section class="photoList list10senNew_01 ">
      <div class="inner2">
        <div class="stage" style="height: 800px;">
          &nbsp;
        </div><!-- /stage-->
      </div><!-- /inner-->
    </section><!-- /photoList-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'winner'
  ],
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  }
}
</script>
<style scoped>
</style>
